// extracted by mini-css-extract-plugin
module.exports = {"list":"TrustlyComponent_list__PTN_a","item":"TrustlyComponent_item__ir5gl"};